
import React from 'react';
import { FacilityOrderExtraSuppliesAddModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderExtraSuppliesAddModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderExtraSuppliesAddModalViewStore(rootStore, componentProps), 'facilityOrderExtraSuppliesAddModalViewStore')
@observer
class FacilityOrderExtraSuppliesAddModal extends React.Component {
    render() {
        return <FacilityOrderExtraSuppliesAddModalTemplate {...this.props} />
    }
}

export default FacilityOrderExtraSuppliesAddModal;
